import accessibleGnavToggle from './module/accessibleGnavToggle';
import addARIACurrent from './module/addARIACurrent';
import pcViewportFixed from './module/pcViewportFixed';
import pcAddIshover from './module/pcAddIshover';
import {fadeOut, fadeIn, fadeToggle} from './module/fade';
import slideToggle from './module/slideToggle';
import article from './module/article';
import addItemsLnkParams from './module/addItemsLnkParams';
import smoothScroll from './module/smoothScroll';

(function ($) {
  
  window.addEventListener('DOMContentLoaded', function(e) {
    addARIACurrent();
    pcViewportFixed();
    pcAddIshover();
    slideToggle();
    article();
    addItemsLnkParams();
    smoothScroll();

	  const unitEl = document.querySelectorAll('.js-fade-unit');

    [].forEach.call(unitEl, function (el) {
      const btn = el.querySelector('.js-fade-switch')
      const target = el.querySelector('.js-fade-target')
      btn.addEventListener('click', function(e) {
        const compStyles = window.getComputedStyle(target);
        if(compStyles.getPropertyValue('display') == 'none') {
          fadeIn(target);
        } else {
          fadeOut(target);
        }
      })
    });
  });
  accessibleGnavToggle();

  const totopEl = document.getElementById('js-totop');
  window.addEventListener('scroll', function(e) {
    if(window.scrollY > 100) {
      totopEl.classList.add('is-show');
    } else {
      totopEl.classList.remove('is-show');
    }
  });

})();
